module.exports = __webpack_public_path__ + "img/Nora/Nora-apple-icon-57x57.png";